/*
 * @Author: cc
 * @Date: 2021-04-28 14:31:18
 * @LastEditTime: 2021-04-29 11:21:14
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\departmentBtns\departmentBtns.js
 * @Description: 部门稿库按钮组件
 * @Special: 这里是继承了父控制器的作用域，可以访问但不能篡改。里面的主要信息，都是根据父控制器的status字段获取，如：rigths（权限）、trench（个人稿库、已收稿库、部门稿库等）
 */
angular.module('iWoPreviewModule').directive('iwoDeptBtns', ['$state', '$window', 'editIsLock', 'myManuscriptService', 'newMediaService', 'editFusionEditorService', 'messagePublishService', 'iWoService', 'editingCenterService', 'editNewspaperService', 'storageListenerService',
    function ($state, $window, editIsLock, myManuscriptService, newMediaService, editFusionEditorService, messagePublishService, iWoService, editingCenterService, editNewspaperService, storageListenerService) {
        return {
            scope: true,
            restrict: 'EA',
            templateUrl: './editingCenter/iWo/iWoPreview/directive/departmentBtns/index.html',
            link: function ($scope) {

                /**
                 * [edit description]跳转到编辑
                 * @return {[type]} [description]null
                 */
                $scope.edit = function () {
                    edit();
                };

                /**
                 * [submit description] 提交
                 * @return  {[type]}  [return description]
                 */
                $scope.submit = function () {
                    $scope.submitList = [{
                        CHNLDOCID: $state.params.iwochnldocid,
                        METADATAID: $state.params.iwometadataid,
                        DOCTYPEID: $scope.list.DOCTYPEID,
                    }];
                    newMediaService.iwoSubmit($scope);
                };

                /**
                 * [departmentSubmit description] 部门传递
                 * @return  {[type]}  [return description]
                 */
                $scope.transmitDraft = function () {
                    editFusionEditorService.departmentSubmit($scope, $scope.list.TITLE);
                };

                /**
                 * [share description] 共享按钮
                 * @return  {[type]}   [return description]
                 */
                $scope.share = function () {
                    newMediaService.iwoShare($scope).then(function (shareObj) {
                        messagePublishService.publish('doEditPageOperation', iWoService.packageShareParams(shareObj));
                    });
                };

                /**
                 * [draftSheet description] 发稿单
                 * @return  {[type]}  [return description]
                 */
                $scope.draftSheet = function(){
                    editingCenterService.draftList(
                        [$scope.list],
                        {
                            serviceid: 'mlf_appfgd',
                            methodname: 'iwoPersonbatchUpdateFgdUsers',
                        },
                        () => {
                            // 
                        }
                    );
                };

                /**
                 * [rejection description] 退稿
                 * @return  {[type]}  [return description]
                 */
                $scope.rejection = function(){
                    let transferData = {
                        item: [$scope.list],
                        rejecectionMethod: 'rejectionShangBanViewDatas',
                        isDepartMent: true
                    };
                    transferData.item[0].DEPARTDOCRELID = $state.params.departdocrelid; // 返回值中未返回此字段，前端手动添加
                    editNewspaperService.rejectionDraft(
                        transferData,
                        () => {
                            storageListenerService.addListenerToIwo('newsPassed');
                            $window.close();
                        },
                        () => {
                            // 
                        }
                    );
                };

                /**
                 * [edit description] 编辑页逻辑
                 * @return  {[type]}  [return description]
                 */
                function edit() {
                    if ($scope.status.isDeptartment) {
                        editIsLock.isLock($scope.data.item, -1).then((data) => {
                            if (data.ISLOCK === 'false') {
                                routerToEditPage();
                            } else {
                                editIsLock.checkUnlockPermissions($scope.data.item, data).then(function () {
                                    routerToEditPage();
                                });
                            }
                        });
                    } else {
                        routerToEditPage();
                    }
                }

                /**
                 * [routerToEditPage description] 跳转到编辑页
                 * @return  {[type]}  [return description]
                 */
                function routerToEditPage() {
                    myManuscriptService.fusionRouter($scope.data.item, $scope);
                    window.close();
                }

                /**
                 * [sendMessage description] 发送按钮
                 * @return  {[type]}  [return description]
                 */
                $scope.sendMessage = function () {
                    editFusionEditorService.sendmessage($scope);
                };
            }
        };
    }]);
